<template>

<form
  class="mx-auto col-sm-8"
  @submit.prevent
>
  <div class="form-group">
    <label for="status">{{ $t('status') }}</label>
    <Combobox
      class="bg-white"
      name='status'
      :hasErrors="errors.has('status')"
      :placeholder="$t('select_a_item')"
      label="name"
      :options="status.rows"
      :initial-value="activeStatus.status"
      v-model="activeStatus.status"
      :reduce="status => status.id"
      v-validate="'required'"
    />

    <small v-show="errors.has('status')" class="form-text">
      {{ errors.first('status') }}
    </small>
  </div>

  <div class="form-group">
    <label for="location">{{ $t('location') }}</label>
    <Combobox
      :multiple="!$route.params.id"
      class="bg-white"
      name='location'
      :hasErrors="errors.has('location')"
      :placeholder="$t('select_a_item')"
      :options="locations"
      :initial-value="activeStatus.location"
      v-model="activeStatus.location"
      v-validate="'required'"
    />

    <small v-show="errors.has('location')" class="form-text">
      {{ errors.first('location') }}
    </small>
  </div>

  <div class="form-group">
    <label for="active_type">{{ $t('active_type') }}</label>
    <Combobox
      :multiple="!$route.params.id"
      class="bg-white"
      :hasErrors="errors.has('active_type')"
      name='active_type'
      :placeholder="$t('select_a_item')"
      label="name"
      :options="activestypes"
      :initial-value="activeStatus.activeType"
      v-model="activeStatus.activeType"
      :reduce="activesTypes => activesTypes.id"
      v-validate="'required'"
    />

    <small v-show="errors.has('active_type')" class="form-text">
      {{ errors.first('active_type') }}
    </small>
  </div>

  <div class="form-group row">
    <div class="col-sm-4 col-sm-offset-2">
      <LoaderButton
        @click="onClick"
      >
        {{ $t('save') }}
      </LoaderButton>
    </div>
  </div>
</form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import Combobox from '@/components/shared/ComboBox'
import location from '@/config/locations'

export default {
  name: 'ActiveStatusForm',
  components: {
    LoaderButton,
    Combobox
  },

  data() {
    return {
      locations: location
    }
  },

  props: {
    activeStatus: {
      type: Object,
      default: () => ({
        id: undefined,
        status: undefined,
        location: [],
        activeType: []
      })
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      status: state => state.status.all
    })
  },

  methods: {
    ...mapActions('activestatus', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evt, done) {
      const valid = await this.$validator.validateAll()
      if (!valid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const { id } = this.activeStatus

      const promise = id
        ? this.edit({ id, data: this.activeStatus })
        : this.create(this.activeStatus)

      const result = await promise

      if (result) {
        this.$router.push({ name: 'listactivestatus' })
      }
    }
  },

  async mounted () {
    const { dispatch } = this.$store

    await dispatch('activestype/fetchAll')
    await dispatch('status/fetchAll')

    if (this.$route.params.id) {
      this.activeStatus.activeType = this.activeStatus.activeType.id
    }
  },

  destroyed () {
    const { dispatch } = this.$store
    this.cleanState()

    dispatch('activestype/cleanState')
    dispatch('status/cleanState')
  }
}
</script>
